import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const OriginNamePropsSchema = z.object({
  originNameValue: z.string(),
})

type OriginNameProps = z.infer<typeof OriginNamePropsSchema>

export class OriginName extends ValueObject<OriginNameProps> {
  public getValue(): string {
    return this.props.originNameValue
  }

  public static create(props: OriginNameProps): OriginName {
    const validatedProps = OriginNamePropsSchema.parse(props)
    return new OriginName(validatedProps)
  }
}
